import { Box, Select as ChakraSelect } from '@chakra-ui/react';
import './index.css';
import 'react-circular-progressbar/dist/styles.css';
import SurveyStatsCards from './SurveyStatsCards';
import RegionStatsCards from './RegionStatsCards';
import BarGraph from './BarGraph';
import ActiveTalatics from './ActiveTalatics';
import EncroachmentBarGraph from './EncroachmentBarGraph';
import CastPieChart from './CastPieChart';
import LineGraph from './LineGraph';

const Dashboard = () => {
  return (
    <Box
      pt={{ base: '105px', md: '95px', xl: '80px', sm: '100px' }}
      px={{ base: '4', md: '8' }}
    >
      <Box mb="10">
        <RegionStatsCards />
      </Box>
      <Box>
        <SurveyStatsCards />
      </Box>
      {/* 
      <Box>
      <ActiveTalatics/>
      </Box> */}
      <Box
        display="flex"
        flexDirection={{ base: 'column', md: 'row' }}
        gap={2}
        flexWrap="wrap"
      >
        <Box flex="1" minW="350px">
          <BarGraph />
        </Box>
        <Box flex="1" minW="350px">
          <CastPieChart />
        </Box>
      </Box>
      <Box>
        <EncroachmentBarGraph />
      </Box>

      <Box>
        <LineGraph />
      </Box>
    </Box>
  );
};

export default Dashboard;
